export default "__VITE_ASSET__kP0hEeXk__"